module.exports = __webpack_public_path__ + "static/media/th-vault--back.fe094f7e.svg";